import { render, staticRenderFns } from "./VideoPlayMan.vue?vue&type=template&id=3c073ffd&scoped=true"
import script from "./VideoPlayMan.vue?vue&type=script&lang=js"
export * from "./VideoPlayMan.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayMan.vue?vue&type=style&index=0&id=3c073ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c073ffd",
  null
  
)

export default component.exports